module.exports = __webpack_public_path__ + "img/outpatientDepartmentFirst.0e6474db.svg";